// extracted by mini-css-extract-plugin
module.exports = {"labelItem":"LabelItem_labelItem__3Z1N8","propSelect":"LabelItem_propSelect__3kI1P","label":"LabelItem_label__noVCU"};